import React, { useState } from 'react';
import PropTypes from 'prop-types';

import BaseInputField from './BaseInputField';
import PasswordStrength from './PasswordStrength';
import { WHITESPACE_KEYCODE } from '../../constants/keyCodeConstants';
import { autoFillStartAnimation } from './Components/InputComponents';

const PasswordField = ({
  field,
  form,
  label,
  placeholder,
  disabled,
  shouldTestPasswordStrength,
  autoFocus,
  onAutofillOrPaste,
  ...props
}) => {
  const [passwordValue, setPasswordValue] = useState('');
  const [isCapsLockOn, setIsCapsLockOn] = useState(false);

  const onChange = (e) => {
    if (shouldTestPasswordStrength) {
      const { value } = e.target;
      setPasswordValue(value);
    }

    field.onChange(e);
  };

  const onKeyDown = (event) => {
    const { value } = field;
    const { keyCode } = event;

    if (!value && keyCode === WHITESPACE_KEYCODE) {
      event.preventDefault();
    }

    if (event.getModifierState('CapsLock')) {
      setIsCapsLockOn(true);
    } else {
      setIsCapsLockOn(false);
    }
  };

  const onAnimationStart = (event) => {
    if (
      onAutofillOrPaste &&
      event.isTrusted &&
      event.animationName === autoFillStartAnimation.getName()
    ) {
      onAutofillOrPaste();
    }
    if (props.onAnimationStart) {
      props.onAnimationStart(event);
    }
  };

  const onPaste = (event) => {
    if (onAutofillOrPaste && event.isTrusted) {
      onAutofillOrPaste();
    }
    if (props.onPaste) {
      props.onPaste(event);
    }
  };

  return (
    <div>
      <BaseInputField
        type="password"
        label={label}
        placeholder={placeholder}
        disabled={disabled}
        form={form}
        field={field}
        {...props}
        onChange={onChange}
        autoFocus={autoFocus}
        onKeyDown={onKeyDown}
        onAnimationStart={onAnimationStart}
        onPaste={onPaste}
        isCapsLockOn={isCapsLockOn}
        maxlength={49}
      />
      {shouldTestPasswordStrength && (
        <PasswordStrength
          passwordValue={passwordValue}
          shouldTestPasswordStrength
        />
      )}
    </div>
  );
};

PasswordField.propTypes = {
  field: PropTypes.shape({
    onChange: PropTypes.func,
    value: PropTypes.string,
  }),
  form: PropTypes.shape({}),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  shouldTestPasswordStrength: PropTypes.bool,
  autoFocus: PropTypes.bool,
  onAutofillOrPaste: PropTypes.func,
  onAnimationStart: PropTypes.func,
  onPaste: PropTypes.func,
};

export default PasswordField;
